export var supportContactInformation = {
    phone: {
        href: 'tel:+18664508560',
        number: '(866) 450-8560',
    },
};
